import axiosInstance from '../axiosInterceptor/axiosInstance'

// The team's games of every season, each with the team's stats in it.
const getTeamGamesStats = async ({ orgId, teamId }) => {
  const url = `v1/orgs/${orgId}/stats/teams/${teamId}/game-log`
  return axiosInstance.get(url)
}

export default getTeamGamesStats
